import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36fdea0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DialogBody" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_3 = {
  class: "CookiesRow D-Flex",
  style: {"gap":"0.5em","flex-direction":"column"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (Branch) => {
        return (_openBlock(), _createElementBlock("div", {
          key: Branch.Name,
          onClick: ($event: any) => (_ctx.SaveLang(Branch)),
          class: "M-Auto P1_25em Shadow2 BG3 Rad2 HoverUp Transition0_25",
          style: {"width":"65%"}
        }, _toDisplayString(Branch.Name), 9, _hoisted_4))
      }), 128))
    ]),
    _hoisted_5
  ]))
}